export default __webpack_public_path__ + "static/media/blue-bg-download.9ff6a34c.webp";